(() => {
  const excluded = 'script,style,noscript,textarea,input,select,option,svg,math,code,pre,[contenteditable]:not([contenteditable="false"]),.zxp-brand-accent';
  const pattern = /\b(Zypher[\s\u00a0]+)(XP)\b/gi;
  const eligible = node => node.parentElement && !node.parentElement.closest(excluded) && /\bZypher[\s\u00a0]+XP\b/i.test(node.data);
  function accent(node) {
    if (!node.isConnected || !eligible(node)) return;
    const content = node.data;
    const fragment = document.createDocumentFragment();
    let offset = 0;
    for (const match of content.matchAll(pattern)) {
      const start = match.index + match[1].length;
      fragment.append(document.createTextNode(content.slice(offset, start)));
      const span = document.createElement('span');
      span.className = 'zxp-brand-accent';
      span.textContent = match[2];
      fragment.append(span);
      offset = start + match[2].length;
    }
    fragment.append(document.createTextNode(content.slice(offset)));
    const label = document.createElement('span');
    label.className = 'zxp-brand-text';
    label.append(fragment);
    node.replaceWith(label);
  }
  function scan(root) {
    if (root.nodeType === Node.TEXT_NODE) return accent(root);
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: node => eligible(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(accent);
  }
  function start() {
    scan(document.body);
    const observer = new MutationObserver(records => {
      const roots = new Set();
      for (const record of records) {
        if (record.type === 'characterData') roots.add(record.target);
        else record.addedNodes.forEach(node => roots.add(node));
      }
      roots.forEach(scan);
    });
    observer.observe(document.body, {childList: true, subtree: true, characterData: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
